import React from "react";
import { FaUser, FaHourglassEnd } from "react-icons/fa";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import one from "../assets/one.png";
import two from "../assets/two.png";
import three from "../assets/three.png";
import { Link } from "react-router-dom";

const HowWorks = () => {
  return (
    <div className="how_works mt-10 py-3">
      <div className="canvas canvas_col">
        <h1 className="text-center fw-bold">¿Cómo Funciona?</h1>

        <div className="grid mt-5">
          <div className="text-center Card">
            <img src={one} width={60} />
            <Link style={{textDecoration: "none", color: "black"}} to="/registro">
              <h2 className="fs-4 fw-bold mt-2">Abre tu Buzón Postalven</h2>
            </Link> 
            <p className="mt-2 font2">
            Estando en Venezuela, USA o España. ¡Es Gratis! y en minutos podrás empezar a gestionar tus envíos a Venezuela.
            </p>
          </div>
          <div className="text-center Card">
            <img src={two} width={60} />
            <h2 className="fs-4 fw-bold mt-2">Envíanos tus Compras</h2>
            <p className="mt-2 font2">
            Usa tu Buzón Postalven de USA o España para enviar tus compras online. Estamos preparados para recibirlas.
            </p>
          </div>
          <div className="Card text-center">
            <img src={three} width={60} />
            <h2 className="fs-4 fw-bold mt-2">Recíbelo en Venezuela</h2>
            <p className="mt-2 font2">
            Te entregamos tu mercancía en más de 250 Agencias en todo el territorio Venezolano.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowWorks;
